import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { Tags } from "components/common";
//#endregion
import { getVatReportStatusAppearance, VatReportTagTone } from "./vatReportModel";
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const toneClass: Record<VatReportTagTone, string> = {
  blue: cssExports.blueTag,
  green: cssExports.greenTag,
  red: cssExports.redTag,
  gray: cssExports.grayTag,
};

interface VatReportStatusTagProps {
  status: WintSuperkollAPIModel.VatReportStatus;
  filedByCustomer: boolean;
}

const VatReportStatusTag: React.FC<VatReportStatusTagProps> = ({ status, filedByCustomer }) => {
  const { label, tone } = getVatReportStatusAppearance(status, filedByCustomer);
  return (
    <Tags
      tags={[LocalizationHelperInstance.getTranslatedEnumValue("Advisor.VatReportStatus", label)]}
      className={toneClass[tone]}
    />
  );
};

export default VatReportStatusTag;
